import { ReactNode } from "react";
import { ModalProps as ModalMuiProps } from "@mui/material";
import { BoxStyled, ModalMuiStyled } from "./style";

interface IModalProps extends Omit<ModalMuiProps, "children"> {
  children: ReactNode;
  maxWidth?: string;
}
export function ModalRoot({
  open,
  onClose,
  children,
  maxWidth = "auto",
}: IModalProps) {
  return (
    <ModalMuiStyled open={open} onClose={onClose}>
      <BoxStyled
        maxWidth={maxWidth}
        style={{
          backgroundColor: "#fff",
        }}
      >
        {children}
      </BoxStyled>
    </ModalMuiStyled>
  );
}
